/**
 * Formats integer minor units as a plain decimal string in major units,
 * with UK thousands separators, exactly two decimal places, and no currency
 * symbol.
 *
 * This is the display counterpart to `formatCurrency` (which prepends the
 * currency symbol) and the display sibling of `formatMinorUnitsAsDecimal`
 * (which omits the thousands separator for machine-parseable CSV cells).
 * Use this for surfaces where the currency symbol is rendered separately
 * (PDF/HTML totals columns aligning the "R" prefix), or where the amount
 * appears in surrounding prose already carrying the currency (`R{amount}/hr`).
 *
 * Example: formatMinorUnitsWithSeparators(625000)   => '6,250.00'
 *          formatMinorUnitsWithSeparators(-10000)   => '-100.00'
 *          formatMinorUnitsWithSeparators(0)        => '0.00' (also for -0)
 *          formatMinorUnitsWithSeparators(10000000) => '100,000.00'
 */
export function formatMinorUnitsWithSeparators(minorUnits) {
    // `-0` (from negating a zero balance) would otherwise print as "-0.00".
    const majorUnits = minorUnits === 0 ? 0 : minorUnits / 100;
    return majorUnits.toLocaleString('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}
